/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionskindparty3Inputs */

const en_openquestionskindparty3 = /** @type {(inputs: Openquestionskindparty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Party`)
};

const pt_openquestionskindparty3 = /** @type {(inputs: Openquestionskindparty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte`)
};

/**
* | output |
* | --- |
* | "Party" |
*
* @param {Openquestionskindparty3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionskindparty3 = /** @type {((inputs?: Openquestionskindparty3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionskindparty3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionskindparty3(inputs)
	return pt_openquestionskindparty3(inputs)
});
export { openquestionskindparty3 as "openQuestionsKindParty" }